<template>
  <div id="app">
    
    <keep-alive>
      <router-view class="router-view" v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view class="router-view"  v-if="!$route.meta.keepAlive"/>
  </div>
</template>
<script>
import Vue from 'vue'
import wjtHttp from './js/http'
export default {
  name: 'App',
  beforeCreate(){
    Vue.prototype.wjtHttp = wjtHttp
  }
}
</script>

<style>
#app {
  font-family: 'Noto Sans SC', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;

  
}
.collapse-title{
  font-size: 18px !important;
}
.el-textarea__inner{
  font-size: 20px !important;
  
}
.el-input__inner{
  font-size: 20px !important;
}
/* 谷歌 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none; 
    margin: 0; 
}
/* 火狐 */
input{
    -moz-appearance:textfield;
}
</style>
